import axios from "axios";
import React, {useEffect, useState} from 'react'
import FirstScreenSlider from "./first-screen/firstscreen-slider";
import FirstScreen from "./first-screen/firstscreen";
import Footer from "./parts/footer";
import CustomGallery from "./gallery/gallery";
import Formats from "./formats/formats";
import AdvantagesOne from "./advantages/advantages";
import Awarding from "./awarding/awarding";
import LeadMagnetOne from "./leadmagnet/leadmagnet-one";
import EbAutOne from "./ebaut-event/ebaut";
import Header from "./parts/header";
import EventThemes from "./themes/themes-base";
import SpeacersBase from "./speacers/speacers-base"
import EventPartnersBase from "./partners/partners-base"
import PartnersTopNew from "./partners/partners-top-new"
import EventPanelBase from "./panel/panel-base";
import ProgramBase from "./program/program-base"
import EventOrganizers from "./organizers/organizers"
import EventAwarding from "./awarding/awarding";
import Statistic from "./statistic/statistic";
import OldSpeacers from "./speacers/old-speacers";
import EventProgramPreview from "./program/program-preview"
import SpeakerQuotes from "./speaker-quotes/quotes";
import Companies from "./companies/companies";
import News from "./news/news";
import BusinessStats from "./businessStats/BusinessStats";

function Home() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/4393?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [])

    let advantagesData = post.advantages
    let ebautData = post.ebaut_event
    let fsData = post.fs_group
    let formatsData = post.formats
    let myGallery = post.gallery
    let awardingData = post.awarding
    let speacersData = post.speacers
    let partnersBaseData = post.partners_bottom
    let partnersTopData = post.partners_top_new
    let panelData = post.panel
    let themesData = post.theme
    let programData = post.program


    return (
        <>
            <Header/>
            <FirstScreenSlider fsData={fsData}/>
            <PartnersTopNew partnersTopData={partnersTopData} />
            <EbAutOne ebautData={ebautData} themesData={themesData}/>
            <AdvantagesOne advantagesData={advantagesData} />
            <SpeakerQuotes />
            <EventThemes />
            <OldSpeacers />

            <Formats formatsData={formatsData}/>
            <CustomGallery myGallery={myGallery} />
            <Companies />
            <BusinessStats />
            <EventOrganizers />
            {/* <EventPartnersBase partnersBaseData={partnersBaseData}/> */}

            {/* 
            <Statistic />
            <EventPanelBase panelData={panelData} />
            <EventAwarding awardingData={awardingData} /> 

            */}

           {/* 
            <Video />



            <ProgramBase programData={programData} />
            
            
            <SpeacersBase speacersData={speacersData}/>
            <News />

            
            <EventProgramPreview />
            
            
            */}
            <Footer />
        </>
    )
}

export default Home;